'use client';

import type { IUser } from '@repo/auth';
import { Avatar, AvatarFallback, AvatarImage, CommandItem } from '@repo/ui';

interface ICommandPaletteUserItemProps {
  user: IUser;
  onSelect: (userId: string) => void;
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function CommandPaletteUserItem({
  user,
  onSelect,
}: ICommandPaletteUserItemProps): React.JSX.Element {
  return (
    <CommandItem value={user.id} onSelect={() => onSelect(user.id)}>
      <Avatar className="h-7 w-7">
        <AvatarImage src={user.image || ''} alt={user.name} referrerPolicy="no-referrer" />
        <AvatarFallback className="text-xs">{getInitials(user.name?.trim() || 'U')}</AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="text-sm font-medium">{user.name}</span>
        <span className="text-xs text-muted-foreground">{user.email}</span>
      </div>
    </CommandItem>
  );
}
